import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_area",
  "use": "svg_area-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_area\"><path d=\"M2 12H0v4c0 1.1.9 2 2 2h4v-2H2v-4ZM2 2h4V0H2C.9 0 0 .9 0 2v4h2V2Zm14-2h-4v2h4v4h2V2c0-1.1-.9-2-2-2Zm0 16v-4h2v4c0 1.1-.9 2-2 2h-4v-2h4Zm-5.04-8.71L14.5 12h-11l2.75-3.53 1.96 2.36 2.75-3.54Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol